import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { Redirect } from 'react-router'
import { StoreProps } from 'src/stores'
import WizardContainer from 'src/components/containers/wizard/WizardContainer'
import Box from 'src/components/containers/wizard/Box'
import Navigation from 'src/components/atoms/wizard/Navigation'
import Question from 'src/components/atoms/wizard/Question'
import FormContainer from 'src/components/containers/FormContainer'
import Answer from 'src/components/atoms/wizard/Answer'
import ProgressBar, {
  ProgressBarContainerWizard
} from '../../atoms/ProgressBar'

interface State {
  valid: boolean
  noRedirect: boolean
}

@inject('wizardStore')
@observer
export class WizardReason extends React.Component<StoreProps, State> {
  constructor(props) {
    super(props)
    const { wizardStore } = props
    const query = new URLSearchParams(location.search)

    this.state = {
      valid: !!wizardStore.basics.planningReason,
      noRedirect: !!query.get('editor')
    }
  }

  componentDidMount() {
    window.dataLayer.push({ event: 'optimize.wizard_planningReason' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.wizard_planningReason' })
  }

  handleAnswerClick = (key) => {
    const { wizardStore } = this.props
    if (this.isChecked(key)) {
      wizardStore.basics.planningReason = null
      this.setState({ valid: false })
    } else {
      wizardStore.basics.planningReason = key
      this.setState({ valid: true })
    }
  }

  isChecked = (id) => {
    const { wizardStore } = this.props
    return id === wizardStore.basics.planningReason
  }

  renderAnswer = (id, text) => {
    return (
      <Answer
        answerKey={id}
        checked={this.isChecked(id)}
        onClick={() => this.handleAnswerClick(id)}>
        {text}
      </Answer>
    )
  }

  render() {
    const { wizardStore } = this.props
    const { valid, noRedirect } = this.state

    if (!wizardStore.readProcessInfo && !noRedirect)
      return <Redirect to='/planung/start/' />

    return (
      <WizardContainer>
        <Box>
          <ProgressBarContainerWizard>
            <ProgressBar start={0} end={10} />
          </ProgressBarContainerWizard>
          <Question>Welches Anliegen haben Sie?</Question>
          <FormContainer>
            {this.renderAnswer('ACUTE_BEREAVEMENT', 'Eingetretener Trauerfall')}
            {this.renderAnswer(
              'IMPENDING_BEREAVEMENT',
              'Bevorstehender Trauerfall'
            )}
            {this.renderAnswer('PROVISION', 'Bestattungsvorsorge')}
          </FormContainer>
        </Box>
        <Navigation
          next={wizardStore.nextWizardStep}
          text='Weiter'
          disabled={!valid}
        />
      </WizardContainer>
    )
  }
}

export default WizardReason



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/WizardReason.tsx